import { SignIn } from "@clerk/clerk-react";
import { Link, useSearchParams } from "@/src/lib/next-compat";

export default function SignInPage() {
  const searchParams = useSearchParams();
  const rawRedirectUrl = searchParams.get("redirect_url");
  const storedPendingJoin = typeof window !== "undefined" ? sessionStorage.getItem("inara_pending_join") : null;
  const redirectUrl = rawRedirectUrl || storedPendingJoin || "/courses";
  const signUpUrl = redirectUrl && redirectUrl !== "/courses"
    ? `/sign-up?redirect_url=${encodeURIComponent(redirectUrl)}`
    : "/sign-up";

  return (
    <div className="flex min-h-screen w-full">
      {/* Left Side - Branding & Testimonial */}
      <div className="hidden lg:flex w-1/2 bg-blue-600 flex-col justify-between p-12 text-white relative overflow-hidden">
        <div className="relative z-10">
          <Link to="/" className="flex items-center gap-2 mb-12">
            <img
              src="/images/logo-v2.png"
              alt="Inara X Logo"
              width={120}
              height={40}
              className="h-8 w-auto brightness-0 invert"
            />
          </Link>

          <h1 className="text-4xl font-bold mb-6 leading-tight">
            Welcome back to your<br />learning journey
          </h1>
          <p className="text-blue-100 text-lg max-w-md">
            Continue where you left off and keep mastering new skills with our AI-powered platform.
          </p>
        </div>


        {/* Decorative Circles */}
        <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 rounded-full bg-blue-500 opacity-20 blur-3xl"></div>
        <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 rounded-full bg-blue-400 opacity-20 blur-3xl"></div>
      </div>

      {/* Right Side - Auth Form */}
      <div className="flex-1 flex flex-col items-center justify-center p-8 bg-white">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8 text-center">
            <Link to="/" className="inline-flex items-center gap-2">
              <img
                src="/images/logo-v2.png"
                alt="Inara X Logo"
                width={120}
                height={40}
                className="h-8 w-auto"
              />
            </Link>
          </div>
          <SignIn
            fallbackRedirectUrl={redirectUrl}
            forceRedirectUrl={redirectUrl !== "/courses" ? redirectUrl : undefined}
            signUpUrl={signUpUrl}
            signUpFallbackRedirectUrl={redirectUrl}
            signUpForceRedirectUrl={redirectUrl !== "/courses" ? redirectUrl : undefined}
            // appearance={{
            //   elements: {
            //     socialButtonsBlockButton: "hidden",
            //     socialButtonsProviderIcon: "hidden",
            //     dividerRow: "hidden",
            //   },
            // }}
          />
        </div>
      </div>
    </div>
  );
}
